<template>
    <div id="main">
        <div class="alert-wrapper">
            <alert-container :messages="msgs" />
        </div>

        <!-- Título -->
        <div class="auditorias">
            <h1 class="title">{{$t('auditorias-dados')}}</h1>
            <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                    <li><a class="a-inativo">{{$t('colaborador')}}</a></li>
                    <li><a aria-current="page">{{$t('auditorias-dados')}}</a></li>
                </ul>
            </nav>
        </div>
        
        <div class="page mb-4">

            <div class="columns">
                <div :class="[isMobile ? 'is-top-mobile' : 'pv-6', 'column', 'is-12']">
                    <div class="columns">
                        <div :class="[isMobile ? 'pv-6' : '', 'column', 'is-3']">
                            <vss-select
                                ref="usuarioFilterInput"
                                class="smaller"
                                v-model="usuarioSelected"
                                label="label"
                                title="usuario"
                                placeholder="msg-selecione-um-usuario"
                                :options="usuarioSelect"
                                @search="loadUsuarios"
                                searchable
                                :loading="usuarioLoading"
                                :height="40"
                                :disabled="origemSelected ? origemSelected.label == 'SISTEMA': false"
                                noClearfix
                                :invalid="usuarioSelected==null"
                                @input="changeUsuario"
                            />
                        </div>
                        <div :class="[isMobile ? 'is-bottom-mobile' : '', 'column', 'is-2']">
                            <verified-date-picker
                                ref="iniInput"
                                class="datepickerfield"
                                title="data-inicial"
                                dateType="startDate"
                                v-model="periodo.ini"
                                :endDate="periodo.fim"
                                :years-range="[-50, 50]"
                                @input="handleDateChange($event, 'inicio')"
                            />
                        </div>
                        <div :class="[isMobile ? 'is-bottom-mobile' : '', 'column', 'is-2']">
                            <verified-date-picker
                                ref="fimInput"
                                class="datepickerfield"
                                title="data-final"
                                dateType="endDate"
                                v-model="periodo.fim"
                                :startDate="periodo.ini"
                                :years-range="[-50, 50]"
                                @input="handleDateChange($event, 'fim')"
                            />
                        </div>
                        <div :class="[isMobile ? 'pv-6' : '', 'column', 'is-2']">
                            <vss-select
                                ref="origemFilterInput"
                                class="smaller"
                                :value="origemSelected"
                                label="label"
                                title="origem"
                                placeholder="msg-selecione-uma-origem"
                                :options="origemSelect"
                                :loading="origemLoading"
                                :height="40"
                                noClearfix
                                clearable
                                :invalid="origemSelected==null"
                                @input="changeOrigem"
                            />
                        </div> 
                        <div :class="[isMobile ? 'pv-6' : '', 'column', 'is-2']">
                            <vss-select
                                ref="operacaoFilterInput"
                                class="smaller"
                                v-model="operacaoSelected"
                                label="label"
                                title="operacao"
                                placeholder="msg-selecione-uma-operacao"
                                :options="operacaoSelect"
                                :loading="operacaoLoading"
                                :height="40"
                                noClearfix
                                clearable
                                mlLabels
                            />
                        </div>  
                        <div :class="[isMobile ? 'pv-6' : '', 'column', 'is-1']" v-if="!isMobile">
                            <b-button 
                                type="is-primary" 
                                icon-right="magnify" 
                                @click="getDados()"
                                v-tippy 
                                :title="$t('pesquisar')"
                            />
                        </div>
                    </div>
                </div>
                <div :class="[isMobile ? 'is-bottom-mobile' : 'pv-6', 'column', 'is-narrow', 'is-1']" v-if="isMobile">
                    <div :class="[isMobile ? '' : 'pt-19', 'columns', 'btns-wrapper',  'is-vcentered', 'is-mobile']">
                        <div :class="[isMobile ? 'is-top-mobile' : '', 'ph-6', 'column', 'pv-0', 'is-first', 'is-narrow', 'is-full']">
                            <button class="btn button search" @click="getDados()">
                                <b-icon icon="magnify"/>
                                <span>{{ $t('pesquisar') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="page results">    
            <!-- Tabela -->
            <div class="table-results" v-show="tableData.length > 0 && !isSearching">
                <b-table 
                    :data="tableData" 
                    :mobile-cards="false" 
                    backend-sorting 
                    hoverable
                >
                    <!-- Dados -->
                    <b-table-column 
                        v-for="(field, index) in tableFields"
                        :key="index"
                        :label="$t(field.label)"
                        :visible="field.visible"
                        :numeric="field.numeric"
                        :sortable="field.sortable"
                        :field="field.key"
                        v-slot="props"
                    >
                        <div v-if="field.key == 'usuario'">
                            <a @click="showAuditoriaDetalheModal(props.row.idauditoria)">
                                {{ props.row.usuario ? props.row.usuario.nome : "—" }}
                            </a>
                        </div>
                        <div v-else-if="field.key == 'datahora'">
                            {{ props.row[field.key] | moment('L LTS') }}
                        </div>
                        <div v-else-if="field.key == 'registro'">
                            {{ props.row.tabela }}
                        </div>
                        <div v-else-if="field.key == 'operacao'">
                            {{ $t(props.row[field.key]) }}
                        </div>
                        <div v-else class="table-data numeric" >
                            {{ props.row[field.key] }}
                        </div>
                    </b-table-column>
                </b-table>
            </div>

            <div
                v-show="isSearching"
                class="searching-loader"
            >
                <svg class="loading">
                    <use :xlink:href="require('@/assets/img/icons/loader.svg')+'#layer'"></use>
                </svg>
                <div>
                    {{ $t('carregando-dados') }}...
                </div>
            </div>

            <!-- Mensagem 'não há dados' e ajuda de utilização -->
            <div
                v-show="(firstTime || noData) && !isSearching"
                class="searching-loader"
            >
                <svg class="bigicon">
                    <use v-if="firstTime" :xlink:href="require('@/assets/img/icons/magnify.svg')+'#layer'"></use>
                    <use v-else :xlink:href="require('@/assets/img/icons/chart-error.svg')+'#layer'"></use>
                </svg>
                <div v-if="firstTime">
                    {{ $t('descricao-ajuda-filtro-relatorio') }}
                </div>
                <div v-else>
                    {{ $t('no-data') }}
                </div>
            </div>

            <b-modal :active.sync="isShowingAuditoriaDetalhe">
                <AuditoriaDadosDetalhada :idauditoria="idAuditoriaDetalhe" />
            </b-modal>

        </div>

        <PaginationViewer
            class="mb-0"
            :resetPagination="pagination.resetPagination"
            :totalItems="pagination.totalRows"
            :perPageOptions="pagination.perPageOptions"
            :optionStarted="pagination.optionStarted"
            @change="updatePagination"
        />

    </div>
</template>

<script>
import ColaboradorService from "@/services/ColaboradorService";
import AuditoriaService from '@/services/AuditoriaService';
import AuditoriaDadosDetalhada from "@/components/colaborador/AuditoriaDadosDetalhada";
import Message from "@/models/Message";

export default {
    components: {
        AuditoriaDadosDetalhada,
    },
    data() {
        return {
            isShowingAuditoriaDetalhe: false,
            idAuditoriaDetalhe: 0,
            service: new AuditoriaService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router), 
            periodo: { 
                ini: this.$moment().subtract(1, 'M').toDate(),
                fim: this.$moment().toDate(),
            },
            usuarioSelect: [],
            usuarioSelected: null,
            usuarioLoading: false,
            origemSelect: [],
            origemSelected: null,
            origemLoading: false,
            operacaoSelect: [],
            operacaoSelected: null,
            operacaoLoading: false,
            tableData: [],
            tableKey: 0,
            tableFields: [
                {key: 'usuario',        label: 'usuario',           sortable: false },
                {key: 'registro',       label: 'registro',          sortable: false },
                {key: 'operacao',       label: 'operacao',          sortable: false },
                {key: 'origem',         label: 'origem',            sortable: false },
                {key: 'datahora',       label: 'data',              sortable: false },
            ],
            firstTime: true,
            noData: false,
            isSearching: false,
            meses: [],
            msgs: [],
            pagination: {
                resetPagination: false,
                perPageOptions: [10,25,50,100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1
            },
            // column: 'cliente',
            // order: 'desc',
            isMobile: false,
            loadedOnce: false,
        };
    },
    created () {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        let body = document.getElementsByTagName("body")[0];

        this.permissao = this.hasPermissionAccess("admin", "colaborador", "usuario-auditorias-dados");
        if ( !this.permissao.read ){
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'auditorias-dados' }
            });
        } else {
            this.loadUsuarios('');        
            this.loadOrigem(); 
            this.loadOperacao()
        }

        body.onresize = this.debounce(this.resize, 150);
    },
    mounted(){
        this.resize();
    },
    beforeDestroy(){
        document.body.onresize = null;
    },
    methods: {
        updatePagination(value){
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.getDados(value.currentPage);
        },
        getDados( currentPage = 1) {
            if(currentPage==1&&this.pagination.currentPage!=1)this.pagination.resetPagination=true;
            if ( this.obligatoryFilters() ) {
                this.isSearching = true;
                this.pagination.totalRows = 0;
                if (this.firstTime) {
                    this.firstTime = false;
                }     
                this.service.findAll(this.getFilter(), currentPage - 1, this.pagination.perPage)
                    .then(this.mapData)
                    .catch(e => {
                        console.error('Erro ao trazer dados das auditorias.', e);
                        this.showMessage('error', 'msg-erro-relatorio');
                        this.noData = true;
                    })
                    .finally(() => {
                        this.isSearching = false;
                    });
            }
        },
        getFilter(){            
            let filtros = {};
            filtros.datainicial = this.$moment(this.periodo.ini).format('DD/MM/YYYY');
            filtros.datafinal = this.$moment(this.periodo.fim).format('DD/MM/YYYY');
            filtros.idusuarioerp = this.usuarioSelected.id;
            filtros.origem = this.origemSelected.label;
            if(this.operacaoSelected!=null) filtros.operacao = this.operacaoSelected.label
            return filtros;
        },
        mapData (r) {
            this.pagination.totalRows = r.totalElements;
            this.tableData = r.content;

            this.noData = this.pagination.totalRows <= 0;    
            this.tableKey++;

            this.resize();
        },
        loadUsuarios (q) {
            this.usuarioLoading = true;

            this.colaboradorService.findListAssociated(q)
                .then(r => {
                    if (r.status != 200) {
                        console.error(`Erro com status ${r.status} ao realizar pesquisa por usuários. Termo: [${q}].`);
                        this.usuarioSelect = [];
                    } else {
                        if (r.length > 1){
                            this.tableFields[1].visible = true;
                        }
                        this.usuarioSelect = r.content.map(v => {
                            return {
                                id: v.idusuarioerp,
                                label: v.nome.toLocaleUpperCase()
                            }
                        });
                        // Adiciona usuario SISTEMA na lista, para que seja possivel mostrar auditorias geradas automaticamente pelo sistema.
                        this.usuarioSelect.push({
                            id: 0,
                            label: "SISTEMA"
                        });
                    }
                })
                .catch(e => {
                    console.error(`Erro ao realizar pesquisa por vendedores. Termo: [${q}].`, e);
                    this.usuarioSelect = [];
                })
                .finally(() => {
                    this.usuarioLoading = false;
                    if (this.usuarioSelect.length > 1){
                        this.tableFields[1].visible = true;
                    }
                });
        },
        loadOrigem () {
            this.origemLoading = true;

            this.service.findAllOrigens()
                .then(r => {
                    if (r.status != 200) {
                        console.error(`Erro com status ${r.status} ao realizar pesquisa por origens.`);
                        this.origemSelect = [];
                    } else {
                        if (r.length > 1){
                            this.tableFields[1].visible = true;
                        }
                        this.origemSelect = r.content.map((v,i) => {
                            return { id: i, label: v }
                        });
                    }
                })
                .catch(e => {
                    console.error(`Erro ao realizar pesquisa por origens.`, e);
                    this.origemSelect = [];
                })
                .finally(() => {
                    this.origemLoading = false;
                    if (this.origemSelect.length > 1){
                        this.tableFields[1].visible = true;
                    }
                });
        },
        loadOperacao () {
            this.operacaoLoading = true;

            this.service.findAllOperacao()
                .then(r => {
                    if (r.status != 200) {
                        console.error(`Erro com status ${r.status} ao realizar pesquisa por operação.`);
                        this.operacaoSelect = [];
                    } else {
                        if (r.length > 1){
                            this.tableFields[1].visible = true;
                        }
                        this.operacaoSelect = r.content.map((v,i) => {
                            return { id: i, label: v }
                        });
                    
                    }
                })
                .catch(e => {
                    console.error(`Erro ao realizar pesquisa por operação.`, e);
                    this.operacaoSelect = [];
                })
                .finally(() => {
                    this.operacaoLoading = false;
                    if (this.operacaoSelect.length > 1){
                        this.tableFields[1].visible = true;
                    }
                });
        },
        validateDatas() {
            let dr = /\d\d\/\d\d\/\d\d\d\d/; // regex para dd/dd/dddd
            let valid = true;
            let iniMoment = null;    
            let fimMoment = null;

            iniMoment = this.$moment(this.periodo.ini);
            /* Validando período de início */
            if (!dr.test( iniMoment.format('L') )) {
                console.error(`Validação falhou no período inicial, data inválida: [${this.periodo.ini}]`);
                this.showMessage('error', 'msg-erro-periodo-inicio');
                valid = false;
            }

            if ( !iniMoment.isValid() ) {
                console.error(`Validação falhou no período inicial, data inválida: [${this.periodo.ini}]`);
                this.showMessage('error', 'msg-erro-periodo-inicio');
                valid = false;
            }

            /* Validando período de fim */
            if ( this.periodo.fim != null && this.periodo.fim != '' ){
                fimMoment = this.$moment(this.periodo.fim);

                if (!dr.test( fimMoment.format('L') )) {
                    console.error(`Validação falhou no período final, data inválida: [${this.periodo.fim}]`);
                    this.showMessage('error', 'msg-erro-periodo-final');
                    valid = false;
                }

                if ( !fimMoment.isValid() ) {                
                    console.error(`Validação falhou no período final, data inválida: [${this.periodo.fim}]`);
                    this.showMessage('error', 'msg-erro-periodo-final');
                    valid = false;
                }
            }

            // Se as duas datas forem válidas
            if (iniMoment !== null && fimMoment !== null && valid) {
                // Se a data de início for acima da data de fim
                if ( fimMoment.isBefore( iniMoment ) ) {
                    console.error(`Validação falhou no período, data inicial maior que a final: [${this.periodo.ini} > ${this.periodo.fim}]`);
                    this.showMessage('error', 'msg-erro-periodo-inicial-final');
                    valid = false;
                }
            }

            return valid;
        },
        obligatoryFilters(){
            let valid = true;
            valid = this.validateDatas();
            if ( this.usuarioSelected == null || this.origemSelected==null){
                console.error(`Filtro(s) obrigatório(s) não foram selecionado(s).`)
                this.showMessage('error', 'msg-campos-obrigatorios');
                valid = false;
                if(this.usuarioSelected==null)this.$refs.usuarioFilterInput.focusedOut=true
                if(this.orgigemSelected==null)this.$refs.origemFilterInput.focusedOut=true
            }
            return valid;
        },
        // limparFiltros () {
        //     this.vendedorOptionSelected = null;
        //     this.clienteOptionSelected = [];
        //     this.fotos = { label: 'todos', id: 0 };
        //     this.motivosNaoVendasSelected = [];
        //     this.empresaOptionSelected = [];
        //     this.periodo = { 
        //         ini: this.$moment().subtract(1, 'M').toDate(),
        //         fim: this.$moment().toDate(),
        //     };
        // },
        showMessage (type, message) {
            this.msgs.push(
                new Message(type, message, true)
            );
        },
        resize () {
            let neededWidth = (document.querySelector('.page').offsetWidth * 0.35) + ((this.meses.length + 1) * 150);
            
            this.isMobile = window.innerWidth <= 768;

            if (this.tableData.length > 0) {
                setTimeout(() => {
                    if (neededWidth > (document.querySelector('.page').offsetWidth + 200)) {
                        document.querySelector('.table-results').setAttribute("style",`width: ${neededWidth}px`);
                    } else {
                        document.querySelector('.table-results').setAttribute("style",'');
                    }
                }, 16);
            }
        },
        redirect(time) {
            setTimeout(() => {
                this.$router.push({ name: "ven-cockpit" });
            }, time * 1000);
        },
        clickEvt(e) {
            let path = e.path || e.composedPath();

            if (this.showSecondaryFilters && !path.includes(this.$refs.secondaryFilter) && !path.includes(this.$refs.btnFilter) ) {
                this.showSecondaryFilters = false;
            }
        },
        showAuditoriaDetalheModal(id){
            this.isShowingAuditoriaDetalhe = !this.isShowingAuditoriaDetalhe;
            this.idAuditoriaDetalhe = id;
        },
        handleDateChange(nova_data, campo) {

            let today = this.$moment();
            let limInferior = this.$moment().subtract(50,'Y');
            let inserido = this.$moment(nova_data,'DD-MM-YYYY');

            switch (campo) {
                case 'inicio':
                    if(inserido.isBefore(limInferior)){
                        // se selecionar ou digitar um dia anterior a 50 anos atrás
                        this.$nextTick( _ => { 
                            this.$set(this.periodo, 'ini', limInferior.toDate());
                        });
                    }else if(inserido.isAfter(today)){
                        // se selecionar ou digitar uma data posterior a hoje
                        this.$nextTick( _ => { 
                            this.$set(this.periodo, 'ini', today.toDate()); 
                        });
                    }else{
                        // se selecionar ou digitar um dia entre hoje e 50 anos atrás
                        this.$nextTick( _ => { 
                            this.$set(this.periodo, 'ini', nova_data);
                        });
                    }
                    break;
                case 'fim':
                    if(inserido.isBefore(this.$moment(this.periodo.ini))){
                        // se selecionar ou digitar um dia antes do filtro de inicio
                        this.$nextTick( _ => { 
                            this.$set(this.periodo, 'fim', this.$moment(this.periodo.ini).toDate());
                        });
                    }else if(inserido.isAfter(today)){
                        // se selecionar ou digitar um dia depois de hoje
                        this.$nextTick( _ => { 
                            this.$set(this.periodo, 'fim', today.toDate());
                        });
                    }else{
                        // se selecionar ou digitar um dia entre o filtro de inicio e hoje
                        this.$nextTick( _ => { 
                            this.$set(this.periodo, 'fim', nova_data);
                        });
                    }
                    break;
            }
        },
        changeOrigem( value ){
            this.origemSelected = value;
            if (value){
                if (value.label == "SISTEMA"){
                this.usuarioSelected = this.usuarioSelect[this.usuarioSelect.length-1];
                } else {
                    if(this.usuarioSelected){
                        if (this.usuarioSelected.label == "SISTEMA") {
                            this.usuarioSelected = null;
                        }
                    }
                }
            }
        },
        changeUsuario(value) {
            this.usuarioSelected = value;
            if (value.label == 'SISTEMA') {
                this.origemSelected = this.origemSelect[this.origemSelect.length-1];
            }
        },
    },
};
</script>

<style lang="scss" scoped>
$padding: 5px;

#main {
    padding: 0 15px 15px 20px;
    height: auto;
    font-size: 13px;

    .pv-6{
        padding: 6px 10px !important;
    }
    .pt-19{
        padding-top: 19px !important;
    }

    .is-top-mobile{
        padding-bottom: 6px;
    }
    .is-bottom-mobile{
        padding-top: 6px;
    }

    .location-icon{
        color: $primary-color;
        &:hover{
            color: $primary-color-hover;
        }
    }

    .results {
        padding: 5px;
        overflow-x: auto;
        border: 1px solid #D0CFCF;
        border-radius: 5px;
        background-color: #fff;
    }

    .table-data {
        display: flex;
        align-items: center;
        
        .atributos {    
            .atributo {
                padding: 8px 0px;
            }
        }
    }

    .btn{
        width: 100%;
        height: 40px;
        color: $sovis-white;
        &.search{
            background-color: $green-alert;
            &:hover{
                background-color: $green-alert-hover;
            }
        }
        &:hover{
            color: $sovis-white;
        }
        &:disabled{
            opacity: 0.6;
        }
    }

}


</style>